// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { error } from 'react-notification-system-redux'

const warnUserCannotPerformAction = () => dispatch => {
  const errorConfig = {
    uid: `${Date.now()}-error`,
    title: 'Warning:',
    autoDismiss: 3,
    children: 'Only the project\'s create user can perform that action.',
  }
  dispatch(error(errorConfig))
}

export default warnUserCannotPerformAction
